// extracted by mini-css-extract-plugin
module.exports = {"iconImageStyle":"FullscreenButton_iconImageStyle_bQFcs","buttonIconPosition":"FullscreenButton_buttonIconPosition_1XpK5"};